import { QueryFactory } from "../../../../Common";
import { BS } from "../../../../Contracts";
export const QUpdatePurchases = QueryFactory(BS.QueryTypes.UpdatePurchases);
//# sourceMappingURL=QUpdatePurchases.js.map